import React, { useEffect, useState } from "react";
import { assetsService } from "../../../api/services/assetsService";
import { useAppSelector } from "../../../infra/hooks";

interface MyAssetDTOProps {
  setAllEmpAssetList: (empassettypes: []) => void;
}
function DTOAddAssetModal({ setAllEmpAssetList }: MyAssetDTOProps) {
  const selector = useAppSelector((state) => state.authSlice);
  const companyId = useAppSelector((state) => state.authSlice.company_id);

  async function getAvailableEmpAssetList() {
    const response = await assetsService.getAvailableEmpAssetList(companyId);
    if (response) {
      const { data }: any = response;
      setAllEmpAssetList(data);
    }
  }
  useEffect(() => {
    getAvailableEmpAssetList();
  }, []);

  return <></>;
}
export default DTOAddAssetModal;
